import { render, staticRenderFns } from "./CommunityWorkNewsCard.vue?vue&type=template&id=1d649600&scoped=true"
import script from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js"
export * from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityWorkNewsCard.vue?vue&type=style&index=0&id=1d649600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d649600",
  null
  
)

export default component.exports